



































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StepMixin, StepStoreMixin } from '@mixin';
import {nl} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            language: nl,
            store: {
                starts_at: null,
            },
            next: {
                disabled: true,
            },
            date: null,
            preventDateWatch: false,
        };
    },

    components: {
        Datepicker,
    },

    mixins: [
        StepMixin,
        StepStoreMixin
    ],

    created() {
        if (!this.store.starts_at) {
            const defaultDate = moment().add(8, 'weeks').add('1', 'days').format('Y-MM-DD');
            this.store.starts_at = defaultDate;
            this.putInStore(this.store);
        }
    },

    methods: {

        change() {
            this.preventDateWatch = true;
            this.store.starts_at = moment(this.date).format('Y-MM-DD');
        },

        async onNext() {
            const startDate = moment(this.store.starts_at);
            const nowDate = moment();

            if (startDate.diff(nowDate, 'weeks') < 8) {
                this.current.starting_date_valid = false;
                this.$router.push(`/apply/${ this.projectId }/project/crowdfunding`);
            } else {
                this.current.starting_date_valid = true;
                this.$router.push(`/apply/${ this.projectId }/project/projectplan`);
            }
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProjectAanvang extends Vue {
    @Watch('store.starts_at')
    onAanvangChange(val) {
        if (this.preventDateWatch) {
            this.preventDateWatch = false;
        } else {
            this.date = this.store.starts_at;
        }

        this.next.disabled = !val;
    }
}

